import { FC, useState } from "react";

interface MarginaliaButtonProps {
	label: string;
	sublabel?: string;
	onClick: () => void;
	variant?: "download" | "copy";
	icon?: "arrow" | "document";
	/** Copy variant only: after a click, show this label with a checkmark instead. */
	clickedLabel?: string;
}

const DownloadArrowIcon = () => (
	<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="shrink-0">
		<path d="M9 1v10M5 7l4 4 4-4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M2 13v2a1 1 0 001 1h12a1 1 0 001-1v-2" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
	</svg>
);

const DocumentIcon = () => (
	<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="shrink-0">
		<path d="M10 1H4a1 1 0 00-1 1v14a1 1 0 001 1h10a1 1 0 001-1V7l-5-6z" stroke="white" strokeWidth="1.5" strokeLinejoin="round" />
		<path d="M10 1v6h5" stroke="white" strokeWidth="1.5" strokeLinejoin="round" />
	</svg>
);

const LinkIcon = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="shrink-0">
		<path d="M6.5 9.5a3.536 3.536 0 005 0l2-2a3.536 3.536 0 00-5-5l-1 1" stroke="#666" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M9.5 6.5a3.536 3.536 0 00-5 0l-2 2a3.536 3.536 0 005 5l1-1" stroke="#666" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

const CheckIcon = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className="shrink-0">
		<path d="M2.5 8.5l3.5 3.5 7.5-8" stroke="#16a34a" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

const MarginaliaButton: FC<MarginaliaButtonProps> = ({ label, sublabel, onClick, variant = "copy", icon = "arrow", clickedLabel }) => {
	const [clicked, setClicked] = useState(false);

	if (variant === "download") {
		return (
			<button
				className="w-full flex items-center gap-3 px-4 py-3 rounded-lg bg-secondary text-white text-left transition-colors hover:bg-secondary-hover focus:outline-none focus:ring-2 focus:ring-secondary/40"
				onClick={onClick}
			>
				{icon === "document" ? <DocumentIcon /> : <DownloadArrowIcon />}
				<div className="flex flex-col">
					<span className="text-sm font-medium text-white leading-tight">{label}</span>
					{sublabel && <span className="text-xs text-tertiary leading-tight mt-0.5">{sublabel}</span>}
				</div>
			</button>
		);
	}

	return (
		<button
			className="w-full flex items-center gap-3 px-4 py-3 rounded-lg bg-white border border-[#ccc] text-[#666] text-left transition-colors hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#ccc]"
			onClick={() => {
				onClick();
				if (clickedLabel) setClicked(true);
			}}
		>
			{clicked ? <CheckIcon /> : <LinkIcon />}
			<span className="text-sm font-medium">{clicked ? clickedLabel : label}</span>
		</button>
	);
};

export { MarginaliaButton };
